import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  zh: require('@/languages/zh.json'),
  en: require('@/languages/en.json'),
  kor: require('@/languages/kor.json'),
  jp: require('@/languages/jp.json'),
  th: require('@/languages/th.json'),
}

const getInitialLocale = () => {
  if (typeof window === 'undefined') return 'en'
  const saved = window.localStorage.getItem('locale')
  return saved && messages[saved] ? saved : 'en'
}

const i18n = new VueI18n({
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
})

export default i18n
